module.exports = __webpack_public_path__ + "img/CALENDARIO.0b42823d.svg";